import React, { Component } from "react";
import uiInfo from "../../ui-info";
import Form, { SimpleItem, Label, GroupItem } from "devextreme-react/form";
import { Button } from "devextreme-react";
import api from "../../api-axios";
import { DataGrid, Column, Pager, Paging, FormItem, Editing } from "devextreme-react/data-grid";
import ShowError from "../../AppServices";
import openReport from "../../openReport";
import UserInfo from "../../UserInfo";
import { EmptyItem } from "devextreme-react/tree-list";
import "./TransferenciaAnualDiat.scss";
import { LoadIndicator } from "devextreme-react/load-indicator";
import notify from "devextreme/ui/notify";
import PaginaToolbar from "../../components/PaginaToolbar";
import { showReportDirect } from "../../showReport";
import { criarTransfDiatDs } from "../../DataSources";

export default class TransferenciaAnualDiat extends Component {
  constructor(props) {

    super(props);

    this.transferirDs = criarTransfDiatDs();
    this._gridTransferencias = React.createRef();


    this.selectBoxOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: true, descricao: "SIM" },
        { id: false, descricao: "NÃO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.modoAlterado = this.modoAlterado.bind(this);
    this.tipoReceitasAlterado = this.tipoReceitasAlterado.bind(this);
    this.setStateSync = this.setStateSync.bind(this);
    this.imprimirLivro = this.imprimirLivro.bind(this);

    this.modoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 1, descricao: "SIMPLES" },
        { id: 2, descricao: "AVANÇADO" },
        { id: 3, descricao: "POR DAM" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
      onValueChanged: this.modoAlterado
    };

    this.tipoOpcoes = {
      editorType: "dxTagBox",
      selectionMode: "multiple",
      searchEnabled: false,
      dataSource: [
        { descricao: "IPTU", tipo: "IPTU" },
        { descricao: "Alvará Funcionamento", tipo: "TLLF" },
        { descricao: "Alvará Transporte", tipo: "TLTA" },
        { descricao: "Alvará Sanitário", tipo: "TLAS" },
        { descricao: "Alvará Construção", tipo: "TLAC" },
        { descricao: "Alvará Habite-se", tipo: "TLHB" },
        { descricao: "Alvará Horário Especial", tipo: "TLFHE" },
        { descricao: "ALvará Publicidade", tipo: "TLVP" },
        { descricao: "Alvará Uso Log. Público", tipo: "TLULP" },
        { descricao: "Lançamentos Diversos", tipo: "TLAD" },
      ],
      placeholder: " ",
      valueExpr: "tipo",
      displayExpr: "descricao",
      showClearButton: true,
      showSelectionControls: true
    };

    this.tipoReceitasOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 1, descricao: "ORIGEM" },
        { id: 2, descricao: "CÓDIGO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
      onValueChanged: this.tipoReceitasAlterado
    };

    this.naturezaOptions = {
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "TODAS" },
        { id: 1, descricao: "TRIBUTARIA" },
        { id: 2, descricao: "NAO TRIBUTARIA" },
      ],
      valueExpr: "id",
      displayExpr: "descricao"
    };

    this.tipoConsolidacaoOptions = {
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "NAO CONSOLIDAR" },
        { id: 1, descricao: "31/12" },
        { id: 2, descricao: "VENC. COTA C/DESCONTO" },
        { id: 3, descricao: "VENC. COTA S/DESCONTO" },
        { id: 4, descricao: "1º VENCIMENTO" },
        { id: 5, descricao: "MAIOR VENCIMENTO" },

      ],
      valueExpr: "id",
      displayExpr: "descricao"
    };


    this.transferirDiat = this.transferirDiat.bind(this);
    this.novaTransferencia = this.novaTransferencia.bind(this);
    this.mostarLivros = this.mostarLivros.bind(this);

    this.state = {
      _uiView: "lista",
      uiCarregando: false,
      mostrarLivros: false,
      uiMsgCarregando: "",
      tipoReceita: 1,
      modo: 1,
      dataInscricao: new Date(),
      stSomenteComDocumento: false,
      stAnexarExistentes: true,
      stSimulacao: true,
      natureza: 0,
      damsSequenciais: "",
      tipoConsolidacao: 0

    }
  }

  async novaTransferencia() {

    this.setStateSync({ uiCarregando: true, uiMsgCarregando: "Carregando dados..." })

    const response = await api.get(
      `/diat/start_inscricao/${UserInfo.getPrefeitura()}`
    );

    const data = response.data;

    if (data) {
      let anoLivro;

      if (data.anosLivros && data.anosLivros.length > 0) {
        anoLivro = data.anosLivros.length == 1 ? data.anosLivros[0] : Math.min(...data.anosLivros);
      }


      this.setState({
        _uiAnosLivro: data.anosLivros,
        anoLivro,
        exercicios: anoLivro?.toString() ?? "",
        uiCarregando: false,
        uiMsgCarregando: undefined,
        tipoConsolidacao: data.tipoConsolidacao,
        _uiView: "transferir"
      });
    }
  }


  modoAlterado(e) {
    this.setState({ modo: e.value });
  }

  tipoReceitasAlterado(e) {
    this.setState({ tipoReceita: e.value });
  }

  setStateSync(state) {
    return new Promise(resolve => {
      this.setState(state, resolve)
    })
  }


  async mostarLivros(e) {
    try {
      await this.setStateSync({ uiCarregando: true, uiMsgCarregando: `Buscando Previes` });

      const resp = await api.get(`/diat/buscar_previsoes/${UserInfo.getPrefeitura()}/${e.row.data.id}`);

      console.log("resposta livros", resp);
      await this.setStateSync({ uiCarregando: false, uiMsgCarregando: "", livros: resp.data, _uiView: "preview" });
    }
    catch (error) {
      notify(error, "error");
    }

  }

  async imprimirLivro(e) {

    await this.setStateSync({ uiCarregando: true, uiMsgCarregando: `Abrindo ${e.row.data.titulo}` });

    showReportDirect(e.row.data.rptStr);

    await this.setStateSync({ uiCarregando: false, uiMsgCarregando: "" });
  }

  render() {
    if (this.state.uiCarregando) {
      return (
        <div className={"content-block dx-card responsive-paddings"}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ textAlign: "center", flex: 1 }}>
              <LoadIndicator width={60} height={60} />
            </div>
            <div style={{ textAlign: "center", flex: 1 }}>
              {this.state.uiMsgCarregando}
            </div>

          </div>
        </div>
      );
    }



    return (
      <React.Fragment>
        <div
          className={"content-block dx-card responsive-paddings"}
          style={{ padding: "30px" }}
        >
          <h3></h3>

          <div style={{ display: this.state._uiView === "transferir" ? "block" : "none" }}>
            <Form formData={this.state} colCount={5} labelLocation="top">
              <GroupItem
                caption="TRANSFERÊNCIA ANUAL DA DÍVIDA ATIVA"
                colSpan={5}
                colCount={5}
              >
                <SimpleItem
                  colSpan={1}
                  dataField={"modo"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.modoOptions}
                >
                  <Label text="Modo" />
                </SimpleItem>

                <SimpleItem dataField={"anoLivro"} colSpan={1} editorType="dxSelectBox" editorOptions={{ dataSource: this.state._uiAnosLivro, searchEnabled: false }}>
                  <Label text="Ano do Livro" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField="dataInscricao"
                  editorType="dxDateBox"
                  editorOptions={{ width: "100%", useMaskBehavior: true }}
                >
                  <Label text="Data da Inscrição" />
                </SimpleItem>
                <SimpleItem dataField={"exercicios"} colSpan={1}
                  visible={this.state.modo === 1 || this.state.modo === 2}
                  helpText="Separados por vírgula, Ex: 2021, 2022">
                  <Label text="Exercícios" />

                </SimpleItem>
                <SimpleItem
                  colSpan={this.state.modo === 3 ? 2 : 1}
                  dataField={"stSimulacao"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.selectBoxOptions}
                  helpText="'SIM' para obter uma previsão do livro"
                >
                  <Label text="Simulação" />
                </SimpleItem>

                <SimpleItem dataField={"damsSequenciais"} colSpan={5}
                  visible={this.state.modo == 3}
                  helpText="Número dos dams separadas por vírgula. Ex: 1415, 1620, 21000001 (deixe em branco para todos)">
                  <Label text="DAM's" />
                </SimpleItem>

                <SimpleItem dataField={"contribuintesIds"} colSpan={5}
                  visible={this.state.modo === 1 || this.state.modo === 2}
                  helpText="Inscrições dos contribuintes separadas por vírgula. Ex: 1415, 1620, 21000001 (deixe em branco para todos)">
                  <Label text="Contribuintes" />
                </SimpleItem>

                <SimpleItem dataField={"imoveisIds"}
                  colSpan={5}
                  visible={this.state.modo == 2}
                  helpText="Inscrições dos imóveis separadas por vírgula. Ex: 1415, 1620, 21000001 (deixe em branco para todos)">
                  <Label text="Imóveis" />
                </SimpleItem>

                <SimpleItem
                  visible={this.state.modo === 1 || this.state.modo === 2}
                  dataField="tiposLancamentos"
                  colSpan={5}
                  editorType={"dxTagBox"}
                  editorOptions={this.tipoOpcoes}
                  helpText="Selecione os tipos de lançamentos que deseja transferir (deixe em branco para TODOS)"
                >
                  <Label text="Tipo de Lançamento" />
                </SimpleItem>

                <SimpleItem
                  colSpan={1}
                  dataField={"tipoReceita"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.tipoReceitasOptions}
                  visible={this.state.modo == 2}
                >
                  <Label text="Tipo Receitas" />
                </SimpleItem>

                <SimpleItem dataField={"uiReceitas"}
                  colSpan={4}
                  visible={this.state.modo == 2}
                  helpText={this.state.tipoReceita == 1
                    ? "Origens das receitas separadas por vírgula. Ex: IPTU, TLLF, TE00"
                    : "Códigos das receitas separadas por vírgula. Ex: 14, 15, 2100001"}>
                  <Label text="Receitas" />
                </SimpleItem>



                <SimpleItem
                  colSpan={1}
                  dataField={"valorMinimo"}
                  editorType={"dxNumberBox"}
                  editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                  cssClass={"txtFrmCpbsNumerico"}
                >
                  <Label text="Valor Mínimo" />
                </SimpleItem>
                <SimpleItem
                  colSpan={2}
                  dataField={"stSomenteComDocumento"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.selectBoxOptions}
                >
                  <Label text="Documento Obrigatório" />
                </SimpleItem>
                <SimpleItem
                  colSpan={2}
                  dataField={"stAnexarExistentes"}
                  editorType={"dxSelectBox"}
                  editorOptions={this.selectBoxOptions}
                >
                  <Label text="Anexar Existentes" />
                </SimpleItem>

                <SimpleItem dataField={"fundamentoLegal"} colSpan={2} helpText={"Obrigatório"}>
                  <Label text="Fundamento Legal" />
                </SimpleItem>

                <SimpleItem colSpan={1} dataField={"natureza"} editorType="dxSelectBox" editorOptions={this.naturezaOptions}>
                  <Label text="Natureza" />
                </SimpleItem>

                <SimpleItem colSpan={2} dataField={"tipoConsolidacao"} editorType="dxSelectBox" editorOptions={this.tipoConsolidacaoOptions}>
                  <Label text="Tipo Consolidação" />
                </SimpleItem>
              </GroupItem>
            </Form>
            <br />
            <div
              style={{
                display: "flex",
                marginTop: "15px",
                justifyContent: "center",
                alignContent: "center",
                justifyItems: "center",
                alignItems: "center",
              }}
            >
              <Button
                text="Voltar"
                icon="chevronleft"
                onClick={() => this.setState({ _uiView: "lista" })}
                width={200}
              />
              <Button
                text="Transferir"
                type="success"
                onClick={this.transferirDiat}
                width={200}
                style={{ marginLeft: "10px" }}
              />
            </div>

          </div>




          <div style={{ display: this.state._uiView === "preview" ? "block" : "none" }}>

            <div
              style={{
                display: "flex",
                marginTop: "15px",
                justifyContent: "left",
                alignContent: "left",
                justifyItems: "left",
                alignItems: "left",
              }}
            >
              <Button
                text="Voltar"
                icon="chevronleft"
                onClick={() => this.setState({ _uiView: "lista" })}
                width={200}
              />

            </div>

            <PaginaToolbar ocultarNovo={true} titulo={"Livros dos Registros"}>
              <DataGrid
                dataSource={this.state.livros}
                showBorders={true}
                rowAlternationEnabled={true}
                columnAutoWidth={true}
              >
                <Column dataField={"livroId"} visible={false} showInColumnChooser={false}>
                  <FormItem visible={false}></FormItem>
                </Column>
                <Column
                  type="buttons"
                  fixed={true}
                  fixedPosition={"left"}
                  buttons={[
                    {
                      hint: "Imprimir livro",
                      icon: "exportpdf",
                      onClick: this.imprimirLivro
                    }
                  ]}
                />
                <Column
                  dataField={"titulo"}
                  caption={"Título"}
                />
              </DataGrid>
            </PaginaToolbar>


          </div>

          <div style={{ display: this.state._uiView === "lista" ? "block" : "none" }}>
            <PaginaToolbar titulo="Transferências" novoCb={this.novaTransferencia} >
              <DataGrid
                ref={(grid) => (this._gridTransferencias = grid)}
                dataSource={this.transferirDs}
                showBorders={true}
                rowAlternationEnabled={true}
                remoteOperations={true}
                wordWrapEnabled={true}
                headerFilter={{ visible: false }}
                filterRow={{ visible: true }}
              >
                <Editing allowUpdating={false} allowDeleting={false} />

                <Column
                  type="buttons"
                  fixed={true}
                  fixedPosition={"left"}
                  buttons={[
                    {
                      hint: "Ver previsoes",
                      icon: "exportpdf",
                      onClick: this.mostarLivros
                    }
                  ]}
                />

                <Column dataField={"id"} alignment={"center"} caption={"#"} width={100} sortIndex={0} sortOrder={"desc"} />
                <Column dataField={"dtCadastro"} dataType={"datetime"} caption={"Data"} alignment={"center"} width={150} />
                <Column dataField={"usuario.nome"} caption={"Usuário"} />
                <Column dataField={"status"} caption={"Status"} />
                <Column dataField={"andamentoStatus"} caption={"Andamento"} />
                <Column dataField={"stSimulacao"} caption={"Simulação"} width={100} />
                <Column dataField={"anoLivro"} caption={"Ano Livro"} alignment={"center"} width={120} />
                <Column dataField={"exercicios"} caption={"Exercicios"} />
                <Column dataField={"valorMinimo"} caption={"Vr. Mínimo"} width={100} dataType={"number"} format={uiInfo.formatoNumerico.n2} visible={false} />
                <Column dataField={"tiposLancamento"} caption={"Tipos Lan."} visible={false} />
                <Column dataField={"contribuintesSeqs"} caption={"Contribuintes"} visible={false} />
                <Column dataField={"imoveisSeqs"} caption={"Imoveis"} visible={false} />
                <Column dataField={"receitas"} caption={"Receitas"} visible={false} />
                <Column dataField={"stDocumentoObrigatorio"} caption={"Doc. Obrigatório"} width={100} visible={false} />
                <Column dataField={"tiposLancamento"} caption={"Tipos Lan."} width={100} visible={false} />

                <Column dataField={"tipoConsolidacao"} caption={"Tp. Consolidação"} width={100} visible={false} />
                <Column dataField={"stAnexarExistentes"} caption={"Anexar Existentes"} width={100} visible={false} />
                <Column dataField={"msgErro"} caption={"Erro"} visible={false} />
                <Column dataField={"stackTrace"} caption={"StackTrace"} visible={false} />

                <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                <Pager
                  showPageSizeSelector={true}
                  allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                />
              </DataGrid>
            </PaginaToolbar>
          </div>
        </div>
      </React.Fragment>
    );
  }
  async transferirDiat() {

    let { anoLivro, dataInscricao, exercicios, stSimulacao, contribuintesIds, tiposLancamentos, tipoReceita, uiReceitas, valorMinimo, stSomenteComDocumento,
      stAnexarExistentes, fundamentoLegal,
      modo, tipoConsolidacao, damsSequenciais } = this.state;

    const tipoFiltroReceita = tipoReceita == 1 ? "ORIGEM" : "SEQUENCIAL";

    console.log("state", this.state);

    const request = {
      prefeituraId: UserInfo.getPrefeitura(),
      dataInscricao,
      anoLivro: Number.parseInt(anoLivro),
      exercicios,
      stSimulacao,
      contribuintesIds,
      tiposLancamentos,
      tipoReceita,
      receitas: uiReceitas,
      tipoFiltroReceita,
      valorMinimo,
      stSomenteComDocumento,
      stAnexarExistentes,
      fundamentoLegal,
      tipoFiltro: modo,
      tipoConsolidacao,
      damsSequenciais
    };

    console.log("request inscricao diat", request);

    try {

      await this.setStateSync({
        uiCarregando: true,
        uiMsgCarregando: "Agendando transferência, por favor aguarde..."
      })

      const response = await api.post(`/diat/inscricao_livro`, request);

      console.log("responta inscricao diat", response.data);

      if (!response.data.sucesso) {
        notify(response.data.msg, "error");
        await this.setStateSync({ uiCarregando: false, uiMsgCarregando: "", _uiView: "lista" });
        return;
      }

      await this.setStateSync({
        uiCarregando: false,
        uiMsgCarregando: "",
        _uiView: "lista"
      });


    }
    catch (error) {
      console.log(error);
      notify(error, "error");
      await this.setStateSync({ uiCarregando: false, uiMsgCarregando: "", mostrarLivros: false });
    }
  }
}
